import { InvoiceSenderDto, InvoiceFromOcrDto } from "@/api/invoiceApi";
import { FeesAndExpenses } from "@/app/invoice/[invoiceId]/_components/createInvoice/InvoiceDetailsAndExpenses/feesAndExpenses";
import { Box, GridItem, Grid } from "@chakra-ui/react";
import { GeneralInfo } from "./generalInfo";
import { BankAccountDto } from "@/types";

type InvoiceDetailsAndExpensesProps = {
    bankAccounts?: BankAccountDto[];
    invoiceId: string;
    submitError?: string;
    totalAmount?: number;
    missingBankAccount?: string;
    invoiceSender?: InvoiceSenderDto;
    onOpenBankDetails?: () => void;
    ocrResponse?: InvoiceFromOcrDto;
    crmId?: string;
    isSubmittingInvoice?: boolean;
    userRole?: string;
    isLoadingOcr?: boolean;
    isLoadingClaim?: boolean;
};

const InvoiceDetailsAndExpenses = ({
    bankAccounts,
    invoiceId,
    submitError,
    totalAmount,
    missingBankAccount,
    invoiceSender,
    onOpenBankDetails,
    ocrResponse,
    crmId,
    isSubmittingInvoice,
    userRole,
    isLoadingOcr,
    isLoadingClaim
}: InvoiceDetailsAndExpensesProps) => {
    return (
        <Grid templateColumns="1fr 2fr" gap={6}>
            <GridItem>
                <Box borderRadius="md">
                    <GeneralInfo
                        bankAccounts={bankAccounts}
                        onOpenBankDetails={onOpenBankDetails}
                        missingBankAccount={missingBankAccount}
                        invoiceSender={invoiceSender}
                        invoiceFromOcr={ocrResponse}
                        crmId={crmId}
                        isLoadingOcr={isLoadingOcr}
                        isLoadingClaim={isLoadingClaim}
                    />
                </Box>
            </GridItem>
            <GridItem>
                <Box borderRadius="md">
                    <FeesAndExpenses
                        submitError={submitError}
                        invoiceId={invoiceId}
                        userRole={userRole ?? "ESP"}
                        totalAmount={totalAmount || 0}
                        ocrResponse={ocrResponse}
                        crmId={crmId}
                        isSubmittingInvoice={isSubmittingInvoice}
                        isLoadingOcr={isLoadingOcr}
                    />
                </Box>
            </GridItem>
        </Grid>
    );
};

export default InvoiceDetailsAndExpenses;
